module.exports = __webpack_public_path__ + "img/status_service.aca1f37d.png";